/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Money_MonthlyInputs */

const en_features_money_monthly = /** @type {(inputs: Features_Money_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`€130 / month`)
};

const pl_features_money_monthly = /** @type {(inputs: Features_Money_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`480 zł / mies.`)
};

/**
* | output |
* | --- |
* | "€130 / month" |
*
* @param {Features_Money_MonthlyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_money_monthly = /** @type {((inputs?: Features_Money_MonthlyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Money_MonthlyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_money_monthly(inputs)
	return en_features_money_monthly(inputs)
});